import '../scss/galeri-page-style.scss';
import GaleriPage from './pages/galeri/index';

document.addEventListener('DOMContentLoaded', () => {
  GaleriPage.init();
});